import styled, { css } from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { handleBoxShadowOutlineBorder } from "core/Button/helpers.js";

// components
import Button from "core/Button";

// styled-components
export const BatchAppovalStyled = styled.div`
    display: grid;
    gap: 16px;
    grid-template-columns: 105px 1px 105px 105px;
`;
export const ButtonStyled = styled(Button)`
    display: block;
    width: 100%;
    height: 28px;
    font-size: 13px;
    padding: 0px;
`;

const disabledGreyState = css`
    background: ${colors.primary.whisker};
    color: ${colors.secondary.dolphin};
    outline: none;
    pointer-events: auto;
    cursor: not-allowed;

    &:hover {
        background: ${colors.primary.whisker};
        color: ${colors.secondary.dolphin};
        border: none;
        outline: none;
        box-shadow: none;
    }
`;

export const FullyPublishButtonStyled = styled(ButtonStyled)`
    box-shadow: ${handleBoxShadowOutlineBorder({
        size: "md",
        color: colors.primary.scheifer
    })};

    ${({ isDisabled }) => isDisabled && disabledGreyState}
`;
export const DenyButtonStyled = styled(ButtonStyled)`
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            ${disabledGreyState};

            background-color: ${colors.secondary.onyx};
            color: ${colors.primary.snow};

            &:hover {
                background-color: ${colors.secondary.onyx};
                color: ${colors.primary.snow};
                border: none;
                outline: none;
                box-shadow: none;
            }
        `}
`;
export const VisuallyApproveButtonStyled = styled(ButtonStyled)`
    ${({ isDisabled }) => isDisabled && disabledGreyState}
`;
export const DividerStyled = styled.div`
    width: 1px;
    background-color: ${colors.primary.pigeon};
    height: 100%;
`;
